import dayjs from 'dayjs'
import Markdown from 'markdown-to-jsx'

import Icon from '@/legacy-src/components/icons/Icon'
import WarningBox from '@/legacy-src/components/WarningBox'
import useCompanyBenefits from '@/legacy-src/hooks/useCompanyBenefits'
import { getTranslate } from '@/legacy-src/utilities/i18n'

const calculateRenewDate = (serviceId, quotas) => {
  const quotaForService = quotas?.find((quota) => quota.services.includes(serviceId))

  const renewDate = dayjs(quotaForService?.endDate).add(1, 'day').format('DD. MM. YYYY')
  return renewDate
}

export const CompanyBenefitsLeft = ({ serviceId }) => {
  const { company, quotas, benefitIsValid } = useCompanyBenefits()
  const { t } = getTranslate()
  const quotaForService = quotas?.find((quota) => quota.services.includes(serviceId))

  if (!company || !quotaForService || !benefitIsValid) {
    return null
  }

  const renewDate = calculateRenewDate(serviceId, quotas)

  return (
    <div className="mb-6 flex items-center gap-4 rounded-xl bg-blue-500 p-3">
      {company.imageUrl && (
        <div className="w-full max-w-[150px]">
          <img src={company.imageUrl} alt={company.name} />
        </div>
      )}
      <div className="text-sm font-bold">
        {quotaForService.remainingEvents > 0
          ? quotaForService.isPerUser
            ? t('component.benefits.freeSessionsPlural', { count: quotaForService.remainingEvents })
            : t('component.benefits.availableSessions')
          : t('component.benefits.willRenew', { date: renewDate })}
      </div>
    </div>
  )
}

export const CoveredWithBenefits = () => {
  const { t } = getTranslate()
  return (
    <div className="flex items-center text-xs">
      <Icon icon="check-small" size="xs" className="mr-1 rounded-full bg-blue-500" />
      <Markdown>{t('component.benefits.cart.covered')}</Markdown>
    </div>
  )
}

export const NotCoveredWithBenefits = () => {
  const { t } = getTranslate()

  return (
    <div className="flex items-center text-xs">
      <Icon icon="info-small" size="xs" className="mr-1 rounded-full bg-yellow-500" />
      <Markdown>{t('component.benefits.cart.notCovered')}</Markdown>
    </div>
  )
}

export const NotAllCoveredWithBenefits = ({ serviceId }) => {
  const { t } = getTranslate()
  const { quotas } = useCompanyBenefits()

  const renewDate = calculateRenewDate(serviceId, quotas)

  const notCoveredText =
    t('component.benefits.cart.notEnough') + ' ' + t('component.benefits.limitWillRenew', { date: renewDate })

  return <WarningBox text={notCoveredText} />
}

export const AllCoveredWithBenefits = () => {
  const { t } = getTranslate()
  const { company } = useCompanyBenefits()

  if (!company) {
    return null
  }

  return (
    <div className="flex w-full items-center gap-4 rounded-xl bg-blue-500 p-5">
      {company.imageUrl && (
        <div className="w-full max-w-[150px]">
          <img src={company.imageUrl} alt={company.name} />
        </div>
      )}
      <div className="text-sm font-bold">{t('component.benefits.cart.allCovered')}</div>
    </div>
  )
}
